import React, { useState, useRef } from "react";
import { QrCode } from "lucide-react";
import BarcodeScannerModal from "./sales/BarcodeScannerModal";
import { getScannerConfig } from "../utils/scannerConfig";

export default function BarcodeScanInput({
  value,
  onChange,
  placeholder = "Ketik atau scan barcode...",
  focusClass = "focus:ring-2 focus:ring-teal-500 focus:border-transparent focus:bg-white",
  className = "",
  disabled = false,
}) {
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const scanBufferRef = useRef("");
  const lastKeyTimeRef = useRef(0);

  const handleKeyDown = (e) => {
    if (disabled) return;
    
    const now = Date.now();
    const minLength = getScannerConfig().minBarcodeLength || 3;

    const isEnter =
      e.key === "Enter" ||
      e.keyCode === 13 ||
      e.code === "NumpadEnter" ||
      e.code === "Enter";
    const isTab = e.key === "Tab";

    // Scanner HID menutup rangkaian scan dengan Enter/Tab.
    // Jangan biarkan diteruskan supaya form tidak submit / fokus tidak pindah.
    if (isEnter || isTab) {
      const buffer = scanBufferRef.current;
      const isScannerFinish =
        buffer.length >= minLength && now - lastKeyTimeRef.current < 150;
      if (isScannerFinish) {
        e.preventDefault();
        e.stopPropagation();
        scanBufferRef.current = "";
        lastKeyTimeRef.current = 0;
      }
      return;
    }

    let char = "";
    if (e.key && e.key.length === 1) {
      char = e.key;
    } else if (e.keyCode >= 48 && e.keyCode <= 90) {
      char = String.fromCharCode(e.keyCode);
      if (!e.shiftKey) char = char.toLowerCase();
    } else if (e.keyCode >= 96 && e.keyCode <= 105) {
      char = String(e.keyCode - 96);
    }
    if (!char) return;

    // Jeda lebih dari 150ms berarti bukan rangkaian scan yang sama.
    if (scanBufferRef.current.length > 0 && now - lastKeyTimeRef.current > 150) {
      scanBufferRef.current = "";
    }
    lastKeyTimeRef.current = now;
    scanBufferRef.current += char;
  };

  return (
    <div className="relative w-full">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        className={
          className
            ? `w-full pr-10 ${className} ${focusClass}`
            : `w-full px-3 py-2 pr-10 border border-slate-200 rounded-lg text-sm text-slate-900 placeholder-slate-400 outline-none transition-colors ${focusClass}`
        }
      />
      <button
        type="button"
        onClick={() => setIsScannerOpen(true)}
        disabled={disabled}
        title="Scan barcode dengan kamera atau scanner terhubung"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-lg text-slate-400 hover:text-teal-600 hover:bg-teal-50 transition-colors disabled:opacity-40"
      >
        <QrCode className="w-4 h-4" />
      </button>
      <BarcodeScannerModal
        isOpen={isScannerOpen}
        onClose={() => setIsScannerOpen(false)}
        onDetected={(code) => onChange(code)}
        title="Scan Barcode Produk"
        subtitle="Arahkan kamera ke barcode, hasilnya otomatis mengisi form"
      />
    </div>
  );
}
